export default "__VITE_ASSET__b645e440__"